import PrivacyPortalCustomization from './PrivacyPortalCustomization'

export default PrivacyPortalCustomization
